import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material'
import { useEffect } from 'react'
import { Loading } from 'router/Loading'
import { useActions, useAppSelector } from 'store/hooks'

import {
  OrderStepContent,
  OrderStepLayout,
} from '../CreateOrder/OrderStepLayout'
import { ProductOrderFooter } from '../CreateOrder/ProductOrderFooter'
import { ProductOrderHeader } from '../CreateOrder/ProductOrderHeader'
import { orderApiSpace } from '../namespaces/orderApiSpace'
import { orderFormSpace } from '../namespaces/orderFormSpace'
import { useGetOrderProdTypeByFormQuery } from '../redux/orders.api'
import { StepComponentProps } from '../types/StepComponentProps'

import style from './OrderStepSelectProdType.module.scss'
import { ProductOrderCard } from './ProductOrderCard'

// шаг 1
// выбор продукта
export function OrderStepSelectProdType({
  completeStep,
  handlePrevious,
}: StepComponentProps) {
  const handlePreviousStep = () => handlePrevious(true)
  const handleCompleteStep = () => completeStep(false)

  const { toggleProductOrder, removeProductOrder } = useActions()
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const products: orderFormSpace.Product[] = useAppSelector(
    state => state.orderForm.forms[currentEditForm].products,
  )

  const { data, isLoading, isError, isFetching } =
    useGetOrderProdTypeByFormQuery(currentEditForm)

  useEffect(() => {
    if (data) {
      // проверка и удаление тех продуктов которые есть в localStorage но нет в полученном json
      const DataIds: number[] = []

      data.list.forEach((item: orderApiSpace.ProductType) => {
        if (item.id) {
          DataIds.push(item.id)
        }
        if (item.children && item.children.list) {
          item.children.list.forEach((childItem: orderApiSpace.ProductType) => {
            if (childItem.id) {
              DataIds.push(childItem.id)
            }
          })
        }
      })
      const StoreIds = products.map(item => item.id)
      StoreIds.forEach(id => {
        if (!DataIds.includes(id)) {
          removeProductOrder(id)
        }
      })
    }
  }, [data])

  const toggleActive = (item: orderApiSpace.ProductType) => {
    toggleProductOrder({ id: item.id, name: item.name })
  }

  if (isLoading || isFetching) return <Loading />
  if (isError) return <>Error</>

  const getDescription = () => {
    switch (currentEditForm) {
      case orderFormSpace.FormType.new:
      case orderFormSpace.FormType.newCompany:
        return 'Выберите один или несколько типов изделия, которые вы хотите заказать'
      case orderFormSpace.FormType.service:
        // eslint-disable-next-line max-len
        return 'Выберите один или несколько типов изделий, по которым необходимо техническое обслуживание'
      default:
        return 'error form'
    }
  }

  return (
    <OrderStepLayout>
      <ProductOrderHeader
        step='Шаг 1'
        title='выбор типа изделия'
        description={getDescription()}
      />
      <OrderStepContent>
        <div className={style.productOrderContent}>
          <div className={style.productList}>
            {data &&
              data.list.map(item => (
                <ProductOrderCard
                  key={item.id}
                  item={item}
                  toggleActive={toggleActive}
                />
              ))}
          </div>
        </div>
      </OrderStepContent>
      <ProductOrderFooter
        nextButton={{
          onClick: handleCompleteStep,
          Icon: <ChevronRightRounded />,
          text: 'Далее',
          disabled: !(products?.length >= 1),
        }}
        prevButton={{
          onClick: handlePreviousStep,
          Icon: <ChevronLeftRounded />,
          text: 'На главную',
        }}
      />
    </OrderStepLayout>
  )
}
